import React, { } from 'react'

export const VideoView = ({ video }) => {

    const { iframe, description, id } = video

    const getResposive = (mesure) => {
        if (screen.width <= 425) {
            return mesure === 'w' ? 280 : 150
        } else if (screen.width <= 768) {
            return mesure === 'w' ? 300 : 180
        } else if (screen.width <= 1024) {
            return mesure === 'w' ? 300 : 200
        } else if (screen.width <= 1440) {
            return mesure === 'w' ? 300 : 170
        }
    }
    return (
        <div className='col-12 col-sm-6 col-md-6 col-lg-4 col-xxl-3 p-2' key={id}>
            <iframe
                className='videoIframe mb-1'
                width={getResposive("w")}
                height={getResposive("h")} src={iframe}
                title="YouTube video player"
                frameBorder="0"
                allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
            <div>
                {description}
            </div>
        </div>
    )
}
